import {
  PROTECT_NATIVE_APP_ID,
  VIDEO_NATIVE_APP_ID,
} from '../../partnerCenterApp/constants/native-apps';

type ScopeListOrgNativeApp = Utils.NonUndefined<
  Utils.ArrayElement<Api.Response['login']['tokenScopeList']>['org']
>['orgNativeApps'];

export const checkIsVideoOnlyCustomer = (
  orgNativeApps: ScopeListOrgNativeApp,
) => {
  if (!orgNativeApps?.length) return false;

  const currentNativeAppIds = orgNativeApps.map(
    (orgNativeApp) => orgNativeApp.nativeApp.id,
  );
  const videoNativeApps = currentNativeAppIds.filter((nativeAppId) =>
    [VIDEO_NATIVE_APP_ID, PROTECT_NATIVE_APP_ID].includes(nativeAppId),
  );

  const nativeAppChecks = [
    videoNativeApps.length > 0,
    // If video native apps are equal to your total apps then you only have video native apps
    videoNativeApps.length === orgNativeApps.length,
  ];

  return nativeAppChecks.every(Boolean);
};
